import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { trackPromise } from 'react-promise-tracker';
import { useFiltersContext } from '../contexts/FiltersContext';
import { useLockersContext } from '../contexts/LockersContext';
import { Locker, PointLocation } from '../data/LockerDataTypes';
import { Api } from '../utils/Api';
import { SearchIcon } from './Miscellaneous';

function ShowAllLockersComponent(props: any) {
    const { t } = useTranslation();
    const [lockersInArea, setLockersInArea]=useState([] as unknown as Locker[] )
    const {
        lockerPluginOptions,
        lockerResponse,
        setUnfilteredLockerResponse
    } = useLockersContext();
    const {
        filterStrategies
    } = useFiltersContext();
    
    useEffect(()=>{
        const ne = {lng: props.mapBounds._ne.lng, lat: props.mapBounds._ne.lat} as PointLocation;
        const sw = {lng: props.mapBounds._sw.lng, lat: props.mapBounds._sw.lat} as PointLocation;
        trackPromise(Api.Get().GetLockersInArea(ne, sw, lockerPluginOptions.countryCode).then(f => {            
        setLockersInArea(f)
        }));
    },[])
    
    const ShowLockersInArea = (): void => {
        filterStrategies.forEach(x=>x.implementation.Clear());
        
        const clearSearchButton = document.getElementById('locker-clear-search') as HTMLButtonElement;
        const searchInput = document.getElementById('locker-search-input') as HTMLInputElement;

        if (clearSearchButton != null && searchInput != null) {
            clearSearchButton.click();
            searchInput.blur();
        }

        setUnfilteredLockerResponse(lockersInArea);
    }

    const ShowAllLockersButtons = (): boolean => {
        return lockersInArea.length != lockerResponse.length && lockersInArea?.length > 0;
    }

    return (
        <>
            {
                ShowAllLockersButtons() &&
                <Button className='lockers-plugin-show-all-lockers-button' onClick={() => { ShowLockersInArea() }}>
                    <SearchIcon />
                    <span className='lockers-plugin-show-all-lockers-span'>{t('showAllTheLockersInArea')}</span>
                </Button>
            }
        </>
    )
}

export default ShowAllLockersComponent;